import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ResultsSection() {
  const outcomes = ["Menos 'episodios eternos' despierta.", 'Menos pelea con tu mente en la madrugada.', "Más sensación de control ('ya sé qué hacer').", 'Un sistema propio basado en tu patrón real (no en teoría).'];
  return <section className="w-full bg-[#1B2838] py-20 px-6 border-y border-[#B8A99A]/5" data-id="element-149">
      <div className="max-w-3xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-bold text-[#F5E6D0] mb-4 font-sans" data-id="element-152">
            Qué cambia en 7 noches:
          </h2>
          <p className="text-[#B8A99A] uppercase tracking-widest text-sm font-bold" data-id="element-153">
            (Sin promesas irreales)
          </p>
        </motion.div>

        <div className="grid gap-4" data-id="element-154">
          {outcomes.map((outcome, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="flex items-center gap-4 bg-[#15202B] p-4 rounded-lg border border-[#B8A99A]/5 hover:border-[#E8614D]/20 transition-colors" data-id="element-155">
              <CheckCircle2 className="w-6 h-6 text-[#E8614D] flex-shrink-0" data-id="element-156" />
              <span className="text-[#F5E6D0] text-lg font-serif" data-id="element-157">
                {outcome}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}